import { decode as base64_decode, encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import Cookies from "js-cookie";
import config from "../config";

class MenuSettingStore {
  menuSetting = [];
  modules = [];
  checkedKeys = [];
  menuSettingEditedArray = [];
  selectedKeysInEditedArray = [];
  searchMenusList = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      menuSetting: observable,
      total: observable,
      loading: observable,
      modules: observable,
      selectedKeysInEditedArray: observable,
      checkedKeys: observable,
      searchMenusList: observable,
      loadData: action,
      getMenuSettingData: action,
      addData: action,
      getModules: action,
      setModules: action,
      deleteRecord: action,
      getUserModules: action,
      globalSearchData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, companyId, roleId, userId, isadmin }) {
    this.loading = true;

    var postData = {
      companyId: companyId,
      page: "rolelist",
      userId: userId,
      roleId,

      fromList: 1,
      isadmin: isadmin,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=user&a=getroles", "postData=" + base64Input);
    // console.log("menusetting ", response?.data?.data);
    // console.log("company Data",response?.data?.data?.companydata)

    const response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/menusettings/getRoles", {
        params: postData,
      });
    this.menuSetting = response?.data?.data;

    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }
  async getUserModules(roleId) {
    var postData = { roleId: roleId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=user&a=usermodules2", "postData=" + base64Input);
    // console.log("menusetting ", response?.data.data);

    const response = await postApi
      .getClient("")
      // .get("http://localhost:3035" + "/menusettings/usermodules", {
      .get(config.NodeUrl + "/menusettings/usermodules", {
        params: postData,
      });

    function addKeyToObjects(data) {
      return data.map((item) => {
        const { moduleId, children, checked, ...rest } = item;
        const updatedItem = { ...rest, moduleId };
        // updatedItem.title=updatedItem.text
        updatedItem.key = moduleId;
        if (checked) {
          updatedItem.selectedKey = moduleId;
        }

        if (children && children.length > 0) {
          updatedItem.children = addKeyToObjects(children);
        }

        return updatedItem;
      });
    }
    const newObj = await addKeyToObjects(response?.data?.data.modules);
    newObj.checkedKeys = response?.data?.data.checkedKeys;
    this.menuSettingEditedArray = newObj;

    return newObj;
  }
  async addData(menuSettingData) {
    var postData = menuSettingData;
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=manageroles&a=role", "postData=" + base64Input);
    // console.log(response.data.message);
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/menusettings/role", { postData });
    return response.data;
  }

  async deleteRecord({ roleId }) {
    const postData = { tokenId: "80bovn8u800tg1aq9bvr73kbhh", roleId: roleId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=manageroles&a=delete", "postData=" + base64Input);
    // console.log(response);
    var response = await postApi
      .getClient("")
      .delete(config.NodeUrl + "/menusettings/deleteRole?&roleId=" + roleId);
    return response;
  }

  async getMenuSettingData(roleId) {
    var postData = { rid: roleId, offset: 0, limit: 1 };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=user&a=getroles", "postData=" + base64Input);
    // console.log(response.data.data[0]);
    const response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/menusettings/getRoles", {
        params: postData,
      });
    return response.data.data[0];
  }
  async getModules(userId, roleId) {
    const postData = { userId: userId, roleId: roleId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=user&a=usermodules2", "postData=" + base64Input);
    const response = await postApi
      .getClient("")
      // .get("http://localhost:3057" + "/menusettings/usermodules", {
      .get(config.NodeUrl + "/menusettings/usermodules", {
        params: postData,
      });
    console.log("get user module resp", response);

    // let checkedKeys = response?.data?.data.checkedKeys.map((i) => Number(i));
    return { ...response?.data?.data };
  }
  async setModules(checkedKeys, modules) {
    this.modules = modules;
    this.checkedKeys = checkedKeys;
    console.log(checkedKeys, modules, "re");
  }

  async globalSearchData() {
    const postData = {
      roleId: JSON.parse(base64_decode(Cookies.get("data"))).roleId,
    };

    const response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/menusettings/globalSearch", {
        params: postData,
      });

    this.searchMenusList = response?.data?.data;
  }
  async getNotificationRule(companyId) {
    const response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/ruleTrigger/getNotificationRule", {
        params: companyId,
      });
    this.notificationRuleData = response.data.data;
    this.notificationCount = response.data.totalCount;
    return response.data;
  }

  async dismissNotification(notificationData) {
    var postData = notificationData;
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/ruleTrigger/dismissNotification", postData);
    return response.data;
  }
}

export default MenuSettingStore;
